export const COMPANY = {
    name: "FTM Group S.r.l.",
    shortName: "FTM Group S.r.l.",
    legalAddress: "Via Popilia, 130 — 87100 Cosenza (CS), Italia",
    operationalAddress: "Via Icaro, 2 — 87040 Castrolibero (CS), Italia",
    vat: "03620430789",
    fiscalCode: "03620430789",
    rea: "CS - 247352",
    shareCapital: "€ 10.000,00 i.v.",
    pec: "ftmgroupsrl@pec.it",
    email: "info@ftmgroup.it",
    phone: "+39 0984 443552",
    phoneHref: "+390984443552",
};
